export const MAX_LOAN_THRESHOLD = 350000

export const EQUIPMENT_TYPES_LABELS: Record<string, string> = {
  'tesla-roof': 'Tesla Roof + Powerwall 3',
  'tesla-solar': 'Tesla Solar Panels + Powerwall 3',
  'standard-solar': 'Standard Solar',
  'storage-only': 'Storage Only'
}

// Fund Realease 
export const FUND_RELEASE_SUPPORT_LINK = "https://oneethos.com/support/fund-release"
export const FUND_RELEASE_LOAN_HELP_LINK = "https://www.climatefirstbank.com/solar-loan-funding-help"
export const TEST_APP_ID = 9_999_999
export const FUNDS_RELEASE_EXPIRES_SECONDS = 168 * 60 * 60 //  7 days in seconds 
export const FUND_RELEASE_RESEND_WAIT_TIME_SECONDS = 10 * 60  // 10 minutes in seconds

export const FUND_RELEASE_TYPES = [
  "Roof Funding Release",
  "Initial Funding Release",
  "Final Funding Release",
  "Full Funding Release"
]

// Consumer protection
export const SOLAR_DEALER_FEES_LINK = "https://www.climatefirstbank.com/cfb-blog/what-are-solar-dealer-fees-and-why-should-i-care"
export const CONSUMER_PROTECTION_RECOMMENDATION_LINK = "https://uploads-ssl.webflow.com/635ae89b651fdf01ef0360a7/662137a89e5f67918b9482b6_IB-Rooftop-Solar-Consumer-Protection-Recommendations.pdf"
export const HOW_TO_SPOT_SOLAR_PANEL_SCAMS_LINK = "https://www.climatefirstbank.com/cfb-blog/what-your-solar-company-should-and-shouldnt-be-doing"
export const ROOFTOP_SOLAR_ENERGY_CONTRACT_LINK = "https://www.energy.gov/eere/solar/articles/where-do-i-sign-understanding-your-rooftop-solar-energy-contract"
export const NEVER_SIGN_A_SOLAR_LOAN_BEFORE_CHECKING_THIS = "https://www.youtube.com/watch?v=lT6Zfff7pyc"
export const HELP_CENTER_LINK = "https://intercom.help/oneethos/en/"
export const APR_EXPLANATION_LINK = "https://www.oneethos.com/apr-explained"

// Review Terms
export const TERMS_AND_CONDITIONS_URL = "https://uploads-ssl.webflow.com/635ae89b651fdf01ef0360a7/63fd1bb51695e86a2e73a542_FINAL-Terms-and-Conditions-Climate-First_Accessible.pdf"
export const PRIVACY_POLICY_URL = "https://uploads-ssl.webflow.com/635ae89b651fdf01ef0360a7/63fd1b125c945e62586bc929_FINAL-Privacy-Policy-Accessible.pdf"
export const ESIGN_AGREEMENT_URL = "https://uploads-ssl.webflow.com/635ae89b651fdf01ef0360a7/63fd34e2f8e1cd8416c96c95_6251ac8b953d1e2a1dfee967_eSign.pdf"

export const COMMUNITY_PROPERTY_STATES = [
  "AZ",
  "CA",
  "ID",
  "LA",
  "NV",
  "NM",
  "TX",
  "WA",
  "WI",
]

export const LOAN_FEE_DISCLOSURE = "*This is the estimate of the loan fees associated with processing your loan. This amount does not include interest charges and is paid over the duration of your loan term."

export const LOAN_MODIFICATION_FEE = 250